<template>
  <div class="rank-list">
    <div class="top_detail" v-if="user.nick_name">
      <van-image
        class="backgroundImage"
        fit="cover"
        :src="require('@/assets/img/personal-header.png')"
      />
      <div class="detail_box">
        <van-image class="header" fit="cover" round :src="user.head" />
        <span class="name">{{ user.nick_name }} </span>
      </div>
      <div class="briefIntroduction">
        {{ user.personal_profile }}
        <div v-if="!user.personal_profile" class="un-sub">
          <div class="un-sub-left">
            <van-icon name="edit" size="20px" />这个用户什么都没有说~
          </div>
        </div>
      </div>
    </div>
    <CommentList @setUser="setUser" :unPersonal="true" />
  </div>
</template>
<script setup>
//引入vant Popup
import { Image as VanImage, Icon as VanIcon } from "vant";
import { ref, onMounted } from "vue";
import CommentList from "../components/CommentList.vue";
import useShare from "@/composiables/useShare";

//更新用户信息
const user = ref({});
const setUser = (data) => {
  user.value = data;
};
onMounted(() => {
  useShare(
    "中山+用户评论主页丨每一个声音都弥足珍贵",
    "https://zsrbapp.zsnews.cn/mobile/images/zsplus.png",
    "多元观点，让文章更具深度和广度",
    window.location.href
  );
});
</script>
<style lang="scss" scoped>
.rank-list {
  background-color: #fff;
  height: 100vh;
  overflow: scroll;
}

.top_detail {
  position: relative;
  margin-bottom: 20px;
  padding-top: 140px;
  .backgroundImage {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 179px;
  }
  .detail_box {
    position: absolute;
    left: 0;
    top: 26px;
    width: 100%;
    display: flex;
    flex-direction: column;
    .header {
      width: 76px;
      height: 76px;
      border: 2px solid #fff;
      margin: 0 auto;
      border-radius: 50%;
      background: #ffffff;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
      margin-bottom: 7px;
    }
    .name {
      font-size: 16px;
      font-weight: 700;
      color: #fff;
    }
  }

  .briefIntroduction {
    padding: 18px 24px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    margin: 0 16px;
    font-size: 14px;
    line-height: 1.5;
    border-radius: 6px;
    text-align: left;
    position: relative;
    z-index: 1;
    color: #c0c4cc;
    .edit-btn-box {
      text-align: center;
      margin-top: 10px;
    }
    .edit-btn {
      display: inline-block;
      background-color: #ffe5e3;
      font-size: 12px;
      color: #ff5c5c;
      height: 20px;
      line-height: 20px;
      padding: 0 10px;
    }
  }
}
.un-sub {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .un-sub-left {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #c0c4cc;
    .van-icon {
      margin-right: 5px;
    }
  }
  .un-sub-right {
    font-size: 12px;
    color: #ff5c5c;
    background: #ffe5e3;
    height: 20px;
    line-height: 20px;
    padding: 0 4px;
  }
}
</style>
